// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "app." + chunkId + "." + {"vendors-node_modules_walletconnect_ethereum-provider_dist_esm_index_js":"b0c6fc58eecc76564429","_a449":"eef2be33c9da385d90ca"}[chunkId] + ".js";
};